<template>
  <div class="mt-4 mb-4 pa-5">
    <Loading v-if="!isLoad"/>
    <div v-show="results">
      <v-dialog v-model="open" width="70%">
        <VideoDialog :dialog="Dialog"/>
      </v-dialog>
      <!-- 一覧表示 -->
      <v-data-table v-if="isList" :headers="headers" :items="dtItems" :items-per-page="30">
        <!-- チャンネルタイトル列用のテンプレート -->
        <template v-slot:item.channel_title="{ item }">
          <v-layout>
            <div class="mr-3">
              <v-img 
                v-on:load="load"
                width="30px" 
                height="30px" 
                :src="item.channel_thumbnail"
              >
              </v-img>
            </div>
            {{ item.channel_title | truncate }}
          </v-layout>
        </template>
        <!-- ビデオ再生列用のテンプレート -->
        <template v-slot:item.id="{ item }">
          <v-icon @click="openDialog(item)">play_circle_outline</v-icon>
        </template>
      </v-data-table>
      <!-- コレクション表示 -->
      <v-layout row wrap v-if="!isList" fluid>
        <v-flex xs12 sm6 md5 md4 lg3 v-for="movie in results" v-bind:key="movie.id">
          <v-card class="ma-2" @click.stop="openDialog(movie)">
            <v-img 
              v-on:load="load"
              class="white--text align-end" 
              width="100%" 
              v-bind:src="movie.thumbnail" 
            >
                <template v-slot:placeholder>
                  <v-layout
                    fill-height
                    align-center
                    justify-center
                    ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </template>
            </v-img>
            <v-card-text class="text--primary">
              <div class="mb-4">{{ movie.title | truncate }}</div>
              <div class="mb-4">
                <v-layout>
                  <div class="mr-3">
                    <v-img class width="30px" height="30px" :src="movie.channel_thumbnail"></v-img>
                  </div>
                  <div>{{ movie.channel_title | truncate }}</div>
                </v-layout>
              </div>
              <div class="mb-4">
                <v-icon>thumb_up</v-icon>: {{ movie.like_count }}
                <v-icon class="ml-2">thumb_down</v-icon>: {{ movie.bad_count }}
                <v-icon class="ml-2">question_answer</v-icon>: {{ movie.comment_count }}
              </div>
              <div>
                最終データ取得日: {{ movie.updated_at }}
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import VideoDialog from "../components/Dialog";
import ApiService from "../common/api.service";
import Loading from "../components/Loading";
import Mixin from '../mixin'

const MAX_SEARCH_RESULTS = 50;

export default {
  name: "Home",
  components: {
    VideoDialog,
    Loading
  },
  data() {
    return {
      listMode: false,
      results: null,
      keyword: "",
      isLoad: false,
      headers: [
        { text: "チャンネル", value: "channel_title" },
        { text: "動画タイトル", align: "left", value: "title" },
        { text: "いいね数", value: "like_count" },
        { text: "悪いね数", value: "bad_count" },
        { text: "view数", value: "view_count" },
        { text: "再生", value: "id", align: "center", sortable: false }
      ],
      dtItems: []
    };
  },
  mixins: [Mixin],
  async mounted() {
    await this.getVideos();
  },
  methods: {
    getVideos: function() {
      ApiService.get("video/popular").then(res => {
        // Card表示用のデータ
        this.results = res.data.result;
        // DataTable表示用に配列オブジェクトに変換して保持
        this.convertTableData(this.results);
      });
    },
    searchVideos: function(keyword) {
      const params = {
        keyword: keyword
      };
      ApiService.get("video/search", params).then(res => {
        // Card表示用のデータ
        this.results = res.data.result;
        // DataTable表示用に配列オブジェクトに変換して保持
        this.convertTableData(this.results);
      });
    },
    convertTableData: function(value) {
      value.forEach(value => {
        const item = {
          title: this.truncate(value.title),
          like_count: value.like_count,
          bad_count: value.bad_count,
          view_count: value.view_count,
          id: value.id,
          channel_title: this.truncate(value.channel_title),
          channel_thumbnail: value.channel_thumbnail
        };
        this.dtItems.push(item);
      });
    },
  },
  created() {
    this.$store.watch(
      state => state.keyword,
      keyword => {
        this.searchVideos(keyword);
        this.convertTableData(this.results);
      }
    )
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
